import {createReducer, on} from '@ngrx/store';
import {EActionStatus} from 'src/app/shared/enums/action-status.enum';
import {ICategoryListState} from '../models/category-list-state.model';
import {
  categoryListAction,
  categoryListEffectError,
  categoryListEffectFailure,
  categoryListEffectSuccess,
  resetCategoryList,
} from './category-list.actions';

const initialState: ICategoryListState = {
  status: EActionStatus.Initial,
  successResponse: null,
  failureReason: '',
  errorMessage: '',
};
export const categoryListReducer = createReducer(
  initialState,
  on(categoryListAction, state => ({
    ...state,
    status: EActionStatus.Pending,
  })),
  on(categoryListEffectSuccess, (state, {response}) => ({
    ...state,
    status: EActionStatus.Success,
    successResponse: response,
  })),
  on(categoryListEffectFailure, (state, {reason}) => ({
    ...state,
    status: EActionStatus.Failure,
    failureReason: reason,
  })),
  on(categoryListEffectError, (state, {error}) => ({
    ...state,
    status: EActionStatus.Error,
    errorMessage: error,
  })),
  on(resetCategoryList, state => ({
    ...state,
    status: EActionStatus.Initial,
    successResponse: null,
    failureReason: '',
    errorMessage: '',
  }))
);
